
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[[...page]]",
      function () {
        return require("private-next-pages/destinations/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[[...page]]"])
      });
    }
  